import { useTheme } from "@hooks";

export const ScheduledTransfer = () => {
  const { theme } = useTheme();

  return (
    <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_10048_203177)">
        <circle cx="18" cy="18.5" r="17" fill={theme.shared.icon.scheduled.background} />
      </g>
      <rect x="0.5" y="1" width="35" height="35" rx="17.5" stroke="#F4F1F2" />
      <path
        d="M18.2546 27.1661C15.8351 27.1661 13.7858 26.3265 12.1066 24.6473C10.4275 22.9682 9.58789 20.9189 9.58789 18.4994C9.58789 16.08 10.4275 14.0307 12.1066 12.3515C13.7858 10.6723 15.8351 9.83276 18.2546 9.83276C20.674 9.83276 22.7233 10.6723 24.4025 12.3515C26.0816 14.0307 26.9212 16.08 26.9212 18.4994C26.9212 20.9189 26.0816 22.9682 24.4025 24.6473C22.7233 26.3265 20.674 27.1661 18.2546 27.1661ZM18.2546 25.5411C20.1865 25.5411 21.8431 24.8505 23.2243 23.4692C24.6056 22.088 25.2962 20.4314 25.2962 18.4994C25.2962 16.5675 24.6056 14.9109 23.2243 13.5296C21.8431 12.1484 20.1865 11.4578 18.2546 11.4578C16.3226 11.4578 14.666 12.1484 13.2848 13.5296C11.9035 14.9109 11.2129 16.5675 11.2129 18.4994C11.2129 20.4314 11.9035 22.088 13.2848 23.4692C14.666 24.8505 16.3226 25.5411 18.2546 25.5411Z"
        fill="#090B1F"
      />
      <path
        d="M21.438 22.6814L22.413 21.7064L18.968 18.2398V13.8848H17.668V18.7598L21.438 22.6814Z"
        fill="#090B1F"
      />
      <defs>
        <clipPath id="clip0_10048_203177">
          <rect
            x="1"
            y="1.5"
            width="34"
            height="34"
            rx="17"
            fill={theme.shared.icon.scheduled.background}
          />
        </clipPath>
      </defs>
    </svg>
  );
};
